import React from 'react';
import classNames from 'classnames';

import useAutopaste from '../../hooks/useAutopaste';

const V2AutopasteSwitch = React.memo(() => {
  const { enabled, handleChange } = useAutopaste();

  return (
    <button
      type="button"
      className={classNames('workspace-tool workspace-tool--autopaste', {
        'workspace-tool--active': enabled,
      })}
      aria-pressed={enabled}
      aria-label="Autopaste"
      title="Autopaste — поиск по скопированному нику"
      onClick={() => handleChange(!enabled)}
    >
      <span className="workspace-tool__letter" aria-hidden="true">
        A
      </span>
    </button>
  );
});

export default V2AutopasteSwitch;
